import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getProjectsSelector = createSelector(
  project => project.projects,
  (projectsById) => getArrayOfObjectValues(projectsById)
);